package com.happyukrainian.revision.kweb.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.happyukrainian.revision.kweb.components.PageContainer
import com.happyukrainian.revision.kweb.config.ButtonStyle
import com.happyukrainian.revision.kweb.config.HUColors
import com.happyukrainian.revision.kweb.pages.routes.FlashCardsRoute
import com.happyukrainian.revision.kweb.pages.routes.TopicRoute
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw
import practicetest.Topic
import repositories.HttpClientTopicRepository

@Page("subject/{subject}/topics")
@Composable
fun TopicPage() {
    val ctx = rememberPageContext()
    val subject = ctx.route.params.getValue("subject")
    var topics by remember { mutableStateOf(emptyList<Topic>()) }
    LaunchedEffect(ctx) {
        HttpClientTopicRepository().fetchTopics(subject).onSuccess {
            topics = it.topics
        }
    }


    Column(modifier = Modifier.fillMaxWidth().minHeight(100.vh).background(HUColors.background)) {
        Row(
            modifier = Modifier.width(100.percent).padding(0.5.vw),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Button(
                modifier = ButtonStyle.toModifier().margin(right = 0.5.vw),
                onClick = {
                    ctx.router.navigateTo("/")
                },
            ) {
                SpanText(text = "Home")
            }
        }
        Box(modifier = Modifier.fillMaxWidth().weight(1f), contentAlignment = Alignment.Center) {
            PageContainer {
                TopicRoute(topics) { topic ->
                    ctx.router.navigateTo("topic/${topic.key}/flashcards")
                }
            }
        }
    }
}